const ALLOWED_HOSTS = new Set(["checkout.stripe.com", "billing.stripe.com"]);

export function isAllowlistedBillingRedirect(url) {
  if (!url || typeof url !== "string") return false;
  let parsed;
  try {
    parsed = new URL(url);
  } catch {
    return false;
  }
  if (parsed.protocol !== "https:") return false;
  if (parsed.username || parsed.password) return false;
  if (parsed.port) return false;
  const host = parsed.hostname.toLowerCase();
  return ALLOWED_HOSTS.has(host);
}

export function navigateAllowlistedBillingUrl(url, options = {}) {
  if (!isAllowlistedBillingRedirect(url)) return false;
  const assign = options.assign || ((href) => window.location.assign(href));
  assign(url);
  return true;
}
